<template>
  <div
    class="overflow-auto pl-2"
    style="height: calc(100vh - 215px)"
    @scroll="$emit('onScroll', $event)"
  >
    <div class="d-flex flex-wrap pb-2 paddinone5px" v-if="jobList.length">
      <div
        v-for="(job, index) in jobList"
        :key="index"
        class="position-relative tp-cardv-main"
        :class="{
          'tp-cardv-main-active': selectedJD && selectedJD.jobID === job.jobID,
          pointer:
            (roles.includes('GET_JOBDASHBOARD') ||
              roles.includes('GET_JOB_STATISTICS')) &&
            job.status === '3' &&
            job.active &&
            !job.closed,
        }"
        @click="
          job.status === '3' && job.active && !job.closed && goToJobDetails(job)
        "
      >
        <div class="d-flex">
          <div style="width: 10%">
            <img
              src="../../assets/img/newworkbench/internalhiring/firsticon.svg"
              alt=""
            />
          </div>
          <div class="ml-2 pt-1" style="width: 53%">
            <div class="wb-custcards-heading">
              <div
                @click="
                  roles.includes('GET_JOBDASHBOARD') &&
                  job.active &&
                  !job.closed
                    ? goToJobDetails(job)
                    : ''
                "
                :class="{
                  pointer:
                    roles.includes('GET_JOBDASHBOARD') &&
                    job.status === '3' &&
                    job.active &&
                    !job.closed,
                }"
                class="relativeclass"
                :style="
                  roles.includes('PUT_JOB') || roles.includes('DELETE_JOB')
                    ? 'width: 90%'
                    : 'width:85%'
                "
              >
                <div class="text-truncate">
                  <span
                    v-b-tooltip.hover.bottom="job.title"
                    class="d-inline-block text-truncate"
                    style="max-width: 100%"
                  >
                    {{ job.title }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="viewMoreJDIndex === index"
            class="
              r2t5
              pff-action-icon-container
              pointer
              d-flex
              align-items-center
            "
          >
            <img
              v-if="roles.includes('CLONE_JOB')"
              v-b-tooltip.hover.bottom="'Clone'"
              @click.stop="cloneJD(job)"
              class="ml-2 newIcons-expand"
              src="../../assets/img/feedbackform/Duplicate.svg"
              alt=""
            />
            <img
              v-if="roles.includes('PUT_JOB')"
              @click.stop="goToEditJD(job)"
              v-b-tooltip.hover.bottom="'Edit'"
              class="ml-2 newIcons-expand"
              src="../../assets/img/feedbackform/edit.svg"
              alt=""
            />
            <img
              v-if="roles.includes('DELETE_JOB')"
              @click.stop="openModal(job, 'delete')"
              v-b-tooltip.hover.bottom="'Delete'"
              class="ml-2 newIcons-expand"
              src="../../assets/img/feedbackform/delete.svg"
              alt=""
            />
            <img
              v-b-tooltip.hover.bottom="'Close'"
              @click.stop="closeViewMore"
              class="ml-2 newIcons-expand"
              src="../../assets/img/feedbackform/cancel.svg"
              alt=""
            />
          </div>
          <div style="width: 34%" class="d-flex justify-content-end" v-else>
            <div
              class="pointer"
              v-if="
                job.status == '3' &&
                job.active &&
                !job.closed &&
                getCustomerDetail.lead &&
                !roles.includes('EXTERNAL_ACCESS')
              "
              @click.stop="openReassign(job)"
            >
              <img
                v-b-tooltip.hover.bottom="'Re-Allocate'"
                src="../../assets/img/newworkbench/internalhiring/reassignvr.svg"
                alt=""
              />
            </div>
            <div
              class="pointer"
              v-if="
                job.active &&
                !job.closed &&
                job.status !== '1' &&
                job.approved &&
                ((getCustomerDetail.lead && job.status !== '3') ||
                  (!getCustomerDetail.lead &&
                    getCustomerDetail.manager &&
                    job.status === '3'))
              "
            >
              <img
                @click.stop="openModal(job, 'close')"
                v-b-tooltip.hover.bottom="'Close Job'"
                src="../../assets/img/newworkbench/internalhiring/closejdsmall.svg"
                alt=""
              />
            </div>
            <div v-if="!job.active || job.closed" class="d-flex">
              <div
                v-if="roles.includes('CLONE_JOB')"
                @click.stop="cloneJD(job)"
                v-b-tooltip.hover.bottom="'Clone'"
              >
                <img
                  class="ml-2 imageshover pointer"
                  src="../../assets/New-imgs/interviewProcess-icons/inactive-clone.svg"
                  alt=""
                />
              </div>
              <div
                v-if="!job.active && roles.includes('DELETE_JOB')"
                class="ml-2"
                v-b-tooltip.hover.top="'Activate'"
                @click.stop="goToEditJD(job)"
              >
                <img
                  class="imageshover pointer"
                  src="../../assets/New-imgs/interviewProcess-icons/newInt-activateicon.svg"
                  alt=""
                />
              </div>
              <div
                v-else-if="
                  job.closed &&
                  (getCustomerDetail.lead || getCustomerDetail.manager)
                "
                class="ml-2 pointer"
                v-b-tooltip.hover.top="'Re-Open'"
                @click.stop="goToEditJD(job)"
              >
                <img
                  class="imageshover"
                  src="../../assets/img/newworkbench/internalhiring/re-open-jd.svg"
                  alt=""
                />
              </div>
            </div>
            <div class="ml-2 pointer">
              <img
                v-b-tooltip.hover.bottom="'View'"
                v-if="!selectedJD || selectedJD.jobID !== job.jobID"
                @click.stop="selectJD(job)"
                class="imageshover"
                src="../../assets/New-imgs/interviewProcess-icons/newInt-eyeicon.svg"
                alt=""
              />
              <img
                v-b-tooltip.hover.bottom="'Hide'"
                v-else
                @click.stop="deselectJob(null)"
                class="imageshover"
                src="../../assets/img/newcreatejob/hideicon.svg"
                alt=""
              />
            </div>
            <div
              class="ml-2 pointer"
              v-if="
                job.active &&
                !job.closed &&
                (getCustomerDetail.lead || getCustomerDetail.manager) &&
                (roles.includes('CLONE_JOB') ||
                  roles.includes('PUT_JOB') ||
                  roles.includes('DELETE_JOB'))
              "
              @click.stop="openViewMore(index)"
            >
              <img
                class="imageshover"
                v-b-tooltip.hover.bottom="'More'"
                src="../../assets/img/newcreatejob/more.svg"
                alt=""
              />
            </div>
          </div>
        </div>
        <template v-if="job.active">
          <div
            @click="
              roles.includes('GET_JOBDASHBOARD') && job.active && !job.closed
                ? goToJobDetails(job)
                : ''
            "
            v-if="roles.includes('PUT_JOB')"
            class="mt-1 jobstatuscard align-items-center ml-2"
          >
            <template>
              <span
                v-if="
                  job.status_display === 'Saved to draft' ||
                  job.status_display === 'IP setup pending'
                "
              >
                <img
                  src="../../assets/img/newworkbench/internalhiring/draft.svg"
                  alt=""
                />
              </span>
              <span
                v-if="job.status_display === 'Sent for approval' && !job.closed"
                ><img
                  src="../../assets/img/newworkbench/internalhiring/noti-sentfrapproval.svg"
                  alt=""
                />
              </span>
              <span
                v-if="
                  (job.status_display === 'Accepted' ||
                    job.status_display === 'Approved' ||
                    job.status_display === 'Published') &&
                  !job.closed
                "
              >
                <img
                  :src="
                    job.onHold
                      ? require('../../assets/img/newworkbench/internalhiring/card-Onhold.svg')
                      : require('../../assets/img/newworkbench/internalhiring/noti-tick.svg')
                  "
                  alt=""
                />
              </span>

              <span v-if="job.status_display === 'Rejected' && !job.closed"
                ><img
                  src="../../assets/img/newworkbench/internalhiring/noti-rejected.svg"
                  alt=""
              /></span>
              <span
                v-if="
                  (job.status_display === 'Not sent for approval' ||
                    job.status_display === 'Not published') &&
                  !job.closed
                "
                ><img
                  src="../../assets/img/newworkbench/internalhiring/noti-close.svg"
                  alt=""
                />
              </span>
              <span class="ml-1 jdcardstatustext" v-if="!job.closed">
                {{
                  (job.status_display === "Accepted" ||
                    job.status_display === "Approved" ||
                    job.status_display === "Published") &&
                  job.onHold
                    ? "On Hold"
                    : job.status_display
                }}</span
              >
            </template>
          </div>
        </template>

        <div
          class="
            mt-2
            d-flex
            justify-content-around
            d-flex
            align-items-center
            new-subcards
            ml-1
          "
          :class="{
            pointer:
              roles.includes('GET_JOBDASHBOARD') &&
              job.status === '3' &&
              job.active &&
              !job.closed,
          }"
          :style="job.active && !job.closed ? '' : 'bottom:15px'"
        >
          <div class="d-flex align-items-center flex-column">
            <div v-if="job.positions < 10" class="wb-new-greenfont">
              0{{ job.positions }}
            </div>
            <div v-else class="wb-new-greenfont">
              {{ job.positions }}
            </div>
            <div class="wb-new-greyfont">Positions</div>
          </div>

          <div class="d-flex align-items-center flex-column">
            <div v-if="job.candidates < 10" class="wb-new-bluefont">
              0{{ job.candidates }}
            </div>
            <div v-else class="wb-new-bluefont">
              {{ job.candidates }}
            </div>
            <div class="wb-new-greyfont">Candidates</div>
          </div>
          <div
            class="d-flex align-items-center flex-column"
            :style="job.active && !job.closed ? '' : 'opacity: 0.5;'"
          >
            <div v-if="job.selected < 10" class="wb-new-yellowfont">
              0{{ job.selected }}
            </div>
            <div v-else class="wb-new-yellowfont">
              {{ job.selected }}
            </div>
            <div class="wb-new-greyfont">Selected</div>
          </div>
        </div>
        <div class="position-relative" v-if="job.automatic">
          <div class="automated-job">Automated Job</div>
        </div>
        <div
          class="inactive-text-box-pfbk inactive-text-workbench"
          v-if="!job.active"
        >
          <div class="inactive-txt">Inactive</div>
        </div>

        <div
          class="inactive-text-box-pfbk inactive-text-workbench"
          v-if="job.closed"
        >
          <div class="inactive-txt">Closed</div>
        </div>
      </div>
    </div>
    <div
      style="margin: auto"
      v-if="showLoader"
      class="d-flex justify-content-center"
    >
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <FolderModal
      :showModal="showFolderModal"
      @close-modal="closeFolder"
      @save-recruiters="saveRecruiters"
    >
    </FolderModal>
    <CloseJobModal
      v-if="showCloseModal"
      :showCloseModal="showCloseModal"
      :deleteData="fromOnHold ? closejob : delDetails"
      :fromOnHold="fromOnHold"
      :type="actionType"
      :fromCloseModal="showDeleteModal"
      @close-modal="closeMainDeleteModal"
      @show-delete-modal="onCloseJobModal"
      @move-to-on-hold="moveToOnHold"
    />
    <DeleteJobModal
      v-if="showDeleteModal"
      :showDeleteModal="showDeleteModal"
      :deleteData="delDetails"
      :buttonLoader="buttonLoader"
      :fromClose="fromClose"
      :type="actionType"
      @delete-event="
        actionType == 'close' || fromClose ? closejd($event) : deleteJD($event)
      "
      @closeDeleteJd="showDeleteModal = false"
      @go-to-close="showCloseModal = true"
    />
    <CloneModal
      :cloneModal="cloneModal"
      :duplicatecloneName="duplicateCloneName"
      header="Clone Job"
      subHeader="New Job Name"
      placeholder="Enter Job Name"
      errorMessage="Job Name already exists"
      @closeCloneModal="closeCloneModal"
      @handle-clone="cloneJob"
      @change-duplicate-name="duplicateCloneName = false"
      :buttonLoader="buttonLoader"
      buttonName="Clone"
    />
    <ConfirmModal
      v-if="confirmModal"
      :confirmModal="confirmModal"
      @handle-submit="closejd"
      @closeModal="confirmModal = false"
      :button="buttonMsg"
      :header="headerMsg"
      :msg="headerContent"
      :imageSrc="computedImageSrc"
    />
  </div>
</template>

<script>
import jobDashboardMixins from "../../components/mixin/jobDashboardMixin";

export default {
  mixins: [jobDashboardMixins],
  data() {
    return {
      numbercards: 40,
      opengraph: false,
    };
  },
};
</script>
<style scoped>
.ihd-jobstatus-approvals-width {
  width: fit-content;
}

.drag-background {
  background: #d8d8d8;
}

.gap-8px {
  gap: 8px;
}

.ihd-gap {
  gap: 1rem;
}

.folder-bar-head {
  font-weight: var(--weight-M);
  font-size: 14px;
  color: #696969;
}

.intern-right-container {
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
  border-radius: 8px;
  width: 30%;
  margin-top: 15px;
  overflow: auto;
  height: calc(100vh - 164px);
}

.post-direct-container {
  background: #f8f8f8;
  border-radius: 10px;
  font-weight: 500;
  font-size: 13px;
  color: #696969;
  padding: 10px;
}

.jobstatuscard {
  position: absolute;
  top: 40px;
}

.ih-recinput .form-control {
  padding: 0.375rem 1.3rem !important;
}

.ih-recsearchicon-pos {
  position: absolute;
  top: 5px;
  left: 5px;
}

.ih-rec-dd-group {
  width: 100%;
  overflow-y: scroll;
}

.new-dd-group {
  height: 200px;
  overflow: auto;
}

.no-border {
  border: none;
  box-shadow: none;
  border-bottom: 1px solid rgba(114, 115, 142, 0.35);
}

.current-jd-name {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;

  color: #6d6d6d;
}

.dashboard-recsearchicon-pos {
  position: absolute;
  top: 5px;
  left: 10px;
}

.dashboard-inputField {
  font-weight: 400;
  font-size: 14px;
  padding: 0.5rem 0.5rem 0.5rem 1.75rem;
}

.total-vendor-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  /* identical to box height */
  color: #72738e;
}

.total-vendor-count-text {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  /* identical to box height */
  color: #72738e;
}

.assign-vendor-text {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  /* identical to box height */

  color: #545454;
}

.select-vendor-bar {
  background: #f9f9f9;
}

.dashboard-select-dropdown-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #696969;
}

.select-vendor-text {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;

  color: #696969;
}

.dashboard-section-content {
  padding: 5px;
  background: #fdfdfd;
  border: 0.7px solid rgba(10, 86, 200, 0.5);
  box-sizing: border-box;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

.delete-modal-title {
  font-weight: 500;
  font-size: 14px;
  color: #545454;
}

.delete-modal-body {
  font-weight: 400;
  font-size: 13px;
  color: #8a8b8c;
}

.ihd-mode {
  overflow: auto;
  min-height: auto;
  max-height: 250px;
}

.ihd-mode-overflow {
  overflow: auto;
  max-height: calc(100vh - 500px);
}

.cursor-default {
  cursor: default;
}

.mg-right-font-weight {
  font-weight: 600 !important;
}

.IP-rounds {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #696969;
}

.re-open-job {
  position: absolute;
  left: 10px;
}

.new-subcards {
  height: 73px;
  border-radius: 10px;
  background: rgba(32, 99, 155, 0.1);
  position: absolute;
  width: 90%;
  bottom: 10px;
}
.view-toggle {
  background: #ffffff;
  border: 1px solid #e9f0f5;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.25);
  border-radius: 30px;
  padding: 0 1px;
}
.paddinone5px {
  padding: 0 0 0 5px;
}
.automated-job {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 9px;
  line-height: 130%;
  color: #ffffff;
  background: #20639b;
  border-radius: 0px 0px 8px 8px;
  width: 97%;
  text-align: center;
  padding: 3px;
  position: absolute;
  top: 88px;
  left: 4px;
  z-index: 0;
}
</style>
